import { ReactNode } from 'react'
import './TotalCard.scss'

interface ITotalCardProps {
    header?: ReactNode;
    content?: ReactNode;
}

const TotalCard = ({header, content}: ITotalCardProps) => {
  return (
    <div className='total-card'>
        <div className="total-card-header">{header}</div>
        <div className="total-card-content">{content}</div>
    </div>
  )
}

export default TotalCard